// Rotates the search box hint ("Search for 'fungicide'", then the next hint) every 3 seconds.
// Pauses while the shopper is typing; never runs for people who prefer reduced motion.
const ROTATE_EVERY_MS = 3000;

const input = document.querySelector('[data-search-hints]');
const hints = (input?.dataset.searchHints || '')
  .split('\n')
  .map((hint) => hint.trim())
  .filter(Boolean);
const pattern = input?.dataset.searchPattern || '';
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (input && pattern && hints.length > 1 && !prefersReducedMotion) {
  let index = 0;
  setInterval(() => {
    if (document.activeElement === input || input.value) return;
    index = (index + 1) % hints.length;
    input.placeholder = pattern.replace('__TERM__', hints[index]);
  }, ROTATE_EVERY_MS);
}
